import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ServicioContenidoModyo } from './modyo-contenido.service';
import type { EstructuraPaginaModyo } from '@core/interfaces/pagina-modyo.interface';
import {
  CONFIGURACION_RUTAS_MODYO,
  type MapaRutasModyo,
  type RutaModyoConfig,
} from '@core/interfaces/rutas-modyo.interface';

@Injectable({ providedIn: 'root' })
export class ServicioRouterModyo {
  private readonly servicioModyo = inject(ServicioContenidoModyo);

  private mapaRutasCache = new Map<string, RutaModyoConfig>();

  public cargarMapaRutas(): Observable<MapaRutasModyo> {
    return this.servicioModyo
      .obtenerEntradaPorSlug<MapaRutasModyo>(
        CONFIGURACION_RUTAS_MODYO.UID_TIPO_CONFIGURACION,
        CONFIGURACION_RUTAS_MODYO.SLUG_MAPA_RUTAS,
      )
      .pipe(
        map((config) => {
          config.rutas.forEach((ruta) => {
            this.mapaRutasCache.set(ruta.path, ruta);
          });
          return config;
        }),
        catchError(() => {
          return of({ rutas: [] });
        }),
      );
  }

  public obtenerConfiguracionRuta(path: string): RutaModyoConfig | null {
    return this.mapaRutasCache.get(path) ?? null;
  }

  public obtenerContenidoPagina(path: string): Observable<EstructuraPaginaModyo | null> {
    const config = this.obtenerConfiguracionRuta(path);

    if (!config) {
      return of(null);
    }

    return this.servicioModyo
      .obtenerEntradaPorSlug<EstructuraPaginaModyo>(config.uidTipo, config.slug)
      .pipe(catchError(() => of(null)));
  }

  public existeRuta(path: string): boolean {
    return this.mapaRutasCache.has(path);
  }

  public obtenerTodasLasRutas(): RutaModyoConfig[] {
    return Array.from(this.mapaRutasCache.values());
  }
}
